import { connect } from "react-redux";
import ThumbnailWorkoutList from "../../../common/Thumbnails/ThumbnailWorkoutList";

function WorkoutHistory(props) {

    const { workoutHistory } = props.User;
    const orientation = {
        s: "y",
        s2: "y",
        m: "y",
        l: "y",
        xl: "y",
    }

    return (
        <>
            <div id="home-v3-workout-history">
                <h5>
                    HISTORY

                    {
                        (workoutHistory && workoutHistory.length == 0) &&
                        <p>Complete a workout to add to your history</p>
                    }

                </h5>

                {
                    (workoutHistory == null || (workoutHistory && workoutHistory.length != 0)) &&
                    <div id="program-videos-panel">
                        <ThumbnailWorkoutList limit={7} content={workoutHistory} favorite={false} midView={2} smallView={1.6} orientation={orientation[props.screenSize]} screenSize={props.screenSize} />
                    </div>
                }

            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Workout: state.Workout,
});

export default connect(mapStateToProps, {

})(WorkoutHistory);